module.exports = __webpack_public_path__ + "static/media/48bb27f0-5594-4193-af93-d0c3a3c53519.3fe13a24.JPG";